/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationSkuDetailsBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return RecommendationSkuDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationSkuDetailsBase>): RecommendationSkuDetailsBase {
        let obj = Object.assign(new RecommendationSkuDetailsBase(), model);
        RecommendationSkuDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationSkuDetailsBase>): RecommendationSkuDetailsBase {
        if (!model) return null;
        return RecommendationSkuDetailsBase.newInstance(<RecommendationSkuDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationSkuDetailsBase) {
        if (!obj) return;

        models.RecommendationSkuDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationSkuDetailsBase): boolean {
        switch (obj.__type)
        {
            case "RecommendationSkuDetailsForAwsEndUserComputingWorkspace":
                Object.setPrototypeOf(obj, models.RecommendationSkuDetailsForAwsEndUserComputingWorkspace.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof RecommendationSkuDetailsBase)[] {
        return [
            models.RecommendationSkuDetailsForAwsEndUserComputingWorkspace,
        ];
    }

    fixupFields() {
    }

}
